// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_GyI","cls2":"ReferenceEvaluationPage-cls2_Uk- ReferenceEvaluationPage-cls1_GyI"};